import { useAuth0 } from '@auth0/auth0-react'
import AuthContext from './../../Contexts/AuthenticationContext'

const Auth0ChildInjector = ({ children }) => {
  const auth = useAuth0();
  

  const authContextValue={
    user: auth.user,
    isLoading: auth.isLoading,
    error: auth.error,
    logout: auth.logout,
    getAccessTokenSilently: auth.getAccessTokenSilently,
    loginWithRedirect: auth.loginWithRedirect,
    isAuthenticated: auth.isAuthenticated
  };
  return (<AuthContext.Provider
  value={authContextValue}
>
 {children}
</AuthContext.Provider>)
}
export default Auth0ChildInjector
